export default __webpack_public_path__ + "static/media/store_svg6.ce924c11.svg";